var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const ClaimedIcon = (_a) => {
    var { color = '#89C900', width = 24, height = 25, fillOpacity = '1' } = _a, props = __rest(_a, ["color", "width", "height", "fillOpacity"]);
    return (React.createElement("svg", Object.assign({ width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M17.1336 10.5536L17.1336 10.5536L17.1395 10.5475C17.6136 10.0571 17.6221 9.27495 17.1336 8.78645C16.6483 8.30118 15.8517 8.30118 15.3664 8.78645L10.58 13.5729L8.63355 11.6264C8.14829 11.1412 7.35171 11.1412 6.86645 11.6264C6.38118 12.1117 6.38118 12.9083 6.86645 13.3936L9.69645 16.2236C9.92914 16.4563 10.2459 16.59 10.58 16.59C10.9141 16.59 11.2309 16.4563 11.4636 16.2236L17.1336 10.5536ZM2.5 12.5C2.5 7.26614 6.76614 3 12 3C17.2339 3 21.5 7.26614 21.5 12.5C21.5 17.7339 17.2339 22 12 22C6.76614 22 2.5 17.7339 2.5 12.5Z", fill: color, stroke: color })));
};
export default ClaimedIcon;
